/* Use customlog.js ONLY if admin allows it */
import config from "../config";
import { customLog } from "../js/customlog.js"; 

export default {
	methods: {
		log(str, type){
			if ( config.isAdminNavAllowed ){
				customLog(str, type);
			}
		}    
	}
}